import { NavArrowRight } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from '../Icon.types';

export const ArrowRightIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <NavArrowRight width={size} height={size} color={color} {...rest} />;

ArrowRightIcon.displayName = 'ArrowRightIcon';
